module.exports = __webpack_public_path__ + "media/images/everfi-background-top-06605ab76fa1cae2c260cc95ca032f69.jpg";